import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const DEFAULT_CFG = { require_foto_evidencia: true, require_codigo_4dig: true, require_gps_capture: true };

// Entregas do entregador + catálogos (bairros/regiões/formas/tipos) + config de captura da empresa.
// Polling 30s reflete mudanças do Admin quase em tempo real. `mountedRef` evita setState após unmount
// (StrictMode compat: re-seta true no mount, senão o 2º ciclo fica false e `load` sai cedo).
export function useMinhasEntregas() {
  const [items, setItems] = useState([]);
  const [lookup, setLookup] = useState({ bai: {}, reg: {}, fpg: {}, tip: {} });
  const [formas, setFormas] = useState([]);
  // multi-empresa: {empresa_id: [{id, nome}]} — formas corretas quando a entrega vem de outra loja do user
  const [formasByEmpresa, setFormasByEmpresa] = useState({});
  const [cfg, setCfg] = useState(DEFAULT_CFG);
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);
  useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false; }; }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/minhas-entregas");
      if (!mountedRef.current) return;
      setItems(r.data);
      const [b, reg, fp, tp, c] = await Promise.all([
        api.get("/bairros"), api.get("/regioes"), api.get("/formas-pgto"),
        api.get("/tipos-entrega").catch(() => ({ data: [] })),
        api.get("/minhas-entregas/config").catch(() => ({ data: {} })),
      ]);
      if (!mountedRef.current) return;
      setFormas(fp.data || []);
      setLookup({
        bai: Object.fromEntries(b.data.map((x) => [x.id, x.nome])),
        reg: Object.fromEntries(reg.data.map((x) => [x.id, x.nome])),
        fpg: Object.fromEntries(fp.data.map((x) => [x.id, x.nome])),
        tip: Object.fromEntries((tp.data || []).map((x) => [x.id, x.nome])),
      });
      setCfg({
        require_foto_evidencia: c.data?.require_foto_evidencia !== false,
        require_codigo_4dig: c.data?.require_codigo_4dig !== false,
        require_gps_capture: c.data?.require_gps_capture !== false,
      });
      setFormasByEmpresa(c.data?.formas_by_empresa || {});
    } catch (e) {
      console.error("Falha ao carregar entregas do entregador", e);
      toast.error(e?.response?.data?.detail || "Erro ao carregar entregas");
    }
    if (mountedRef.current) setLoading(false);
  };
  // `load` é closure estável do hook — roda no mount + a cada 30s.
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  return { items, setItems, lookup, formas, formasByEmpresa, cfg, loading, load, mountedRef };
}
